const ARR_QUERY_FAMILIES = [
    "arr-schedule",
    "board-stats-arr-schedule",
    "board-stats-arr-waterfall",
    "board-stats-dollar-retention",
    "board-stats-magic-number",
    "board-stats-gtm-efficiency",
    "board-stats-ltv-cac",
    "board-stats-cac",
    "sales-close-push-pull",
    "scenario-booked-detail-drilldown",
];

const isArrFamily = (value) => typeof value === "string" && ARR_QUERY_FAMILIES.some(
    family => value === family || value.startsWith(`${family}-`)
);

// Chart/list keys use "<customer>_<family>"; account drawers and evidence use
// [customer, family, ...]. Do not match another customer's similar ID or a
// filter value that happens to contain a metric name.
export const isArrDependentQuery = (queryKey, accountId) => {
    if (!Array.isArray(queryKey) || typeof queryKey[0] !== "string") return false;
    const root = queryKey[0];
    if (accountId) {
        return root === accountId ? isArrFamily(queryKey[1])
            : root.startsWith(`${accountId}_`) && isArrFamily(root.slice(accountId.length + 1));
    }
    return isArrFamily(queryKey[1])
        || ARR_QUERY_FAMILIES.some(family => root.endsWith(`_${family}`) || root.includes(`_${family}-`));
};

export const invalidateArrScheduleConsumers = async (queryClient, accountId) => {
    if (!accountId) return;
    const filters = {predicate: query => isArrDependentQuery(query.queryKey, accountId)};
    // Discard reads started before the save, including first loads. Active
    // consumers refetch; inactive ones remain stale until the user returns.
    await queryClient.cancelQueries(filters);
    // A successful write remains successful even if the subsequent read fails.
    // Each consumer presents its own loading/error state.
    void queryClient.invalidateQueries(filters).catch(() => {});
};
